import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';

const VideoPlayer = ({
  videoUrl,
  videoPlaying,
  loop,
  handleVideoEnded,
  handleProgress,
  muted,
  seekTo,
}) => {
  const playerRef = useRef(null);

  useEffect(() => {
    if (seekTo !== null && typeof seekTo !== 'undefined') {
      playerRef.current.seekTo(seekTo, 'fraction');
    }
  }, [seekTo]);

  // Show the video only after it's loaded to prevent any flashes
  const [videoOpacity, setVideoOpacity] = useState('0');
  const handleVideoLoading = () => {
    setVideoOpacity('1');
    // console.log('video loaded');
  };

  return (
    <div className={`sixteenNineBox mb8`}>
      <ReactPlayer
        id="reactPlayerVideo"
        className={`sixteenNineBoxInner`}
        style={{ opacity: videoOpacity }}
        width="100%"
        height="100%"
        url={videoUrl} // correct url
        loop={loop}
        controls={false}
        playsinline // Prevent Vimeo from automatically entering fullscreen
        onReady={handleVideoLoading}
        onProgress={handleProgress}
        playing={videoPlaying}
        // onPause={handlePause} // I think we need to disable pause on all videos?
        // onStart={handleVideoStart} // Start callback
        onEnded={handleVideoEnded} // End callback. Could be useful for looping part of a video once it has played through
        muted={muted}
        volume={1} // Required for Muted to work
        ref={playerRef} // Shouldn't need a ref; it would be used to access the internal player (Vimeo, Youtube, whatever)
      />
    </div>
  );
};

VideoPlayer.propTypes = {
  videoUrl: PropTypes.string.isRequired,
  videoPlaying: PropTypes.bool.isRequired,
  loop: PropTypes.bool.isRequired,
  handleVideoEnded: PropTypes.func,
  handleProgress: PropTypes.func,
  muted: PropTypes.bool,
  seekTo: PropTypes.number,
};

VideoPlayer.defaultProps = {
  muted: true,
};

export default VideoPlayer;
